<div class="claim_body">
    <div class="top_panel">
        <h3>Notes</h3>
        <span (click)="close()" class="close">
            <img src="https://cdn.elitehw.com/images/cross.webp" />
        </span>
    </div>
    <div class="formarea overflow-auto">
      <div>
        <button (click)="handleNotes('add')" class="add_btn">
          <mat-icon>add_circle</mat-icon>
          Add notes
        </button>
      </div>
      <mat-tab-group
      animationDuration="0ms"
      (selectedTabChange)="onTabChange($event)"
    >
      <mat-tab [label]="tabNameList.all">
        <fury-notes-table
          [displayedColumns]="columns"
          [dataSource]="dataSource"
          [fileClaimId]="data.fileClaimId"
          [fileClaimNumber]="data.fileClaimNumber"
        ></fury-notes-table>
        <mat-paginator
          *ngIf="this.totalCount > 0"
          [pageSizeOptions]="[5, 30, 50, 100, 9999]"
          [pageSize]="pageSize"
          [length]="totalCount"
          [pageIndex]="pageIndex"
          (page)="pageSizeChange($event)"
          showFirstLastButtons
          [selectConfig]="selectConfig"
          [ngClass]="{ 'mat-pegig': pageSize === 9999 }"
          aria-label="Select page of periodic elements"
        >
        </mat-paginator>
      </mat-tab>
      <mat-tab [label]="tabNameList.new">
        <fury-notes-table
          [displayedColumns]="columns"
          [dataSource]="dataSource"
          [fileClaimId]="data.fileClaimId"
          [fileClaimNumber]="data.fileClaimNumber"
        ></fury-notes-table>
        <mat-paginator
          *ngIf="this.totalCount > 0"
          [pageSizeOptions]="[5, 30, 50, 100, 9999]"
          [pageSize]="pageSize"
          [length]="totalCount"
          [pageIndex]="pageIndex"
          (page)="pageSizeChange($event)"
          showFirstLastButtons
          [selectConfig]="selectConfig"
          [ngClass]="{ 'mat-pegig': pageSize === 9999 }"
          aria-label="Select page of periodic elements"
        >
        </mat-paginator>
      </mat-tab>
      <mat-tab [label]="tabNameList.assigned">
        <fury-notes-table
          [displayedColumns]="columns"
          [dataSource]="dataSource"
          [fileClaimId]="data.fileClaimId"
          [fileClaimNumber]="data.fileClaimNumber"
        ></fury-notes-table>
        <mat-paginator
          *ngIf="this.totalCount > 0"
          [pageSizeOptions]="[5, 30, 50, 100, 9999]"
          [pageSize]="pageSize"
          [length]="totalCount"
          [pageIndex]="pageIndex"
          (page)="pageSizeChange($event)"
          showFirstLastButtons
          [selectConfig]="selectConfig"
          [ngClass]="{ 'mat-pegig': pageSize === 9999 }"
          aria-label="Select page of periodic elements"
        >
        </mat-paginator>
      </mat-tab>
      <mat-tab [label]="tabNameList.closed">
        <fury-notes-table
          [displayedColumns]="columns"
          [dataSource]="dataSource"
          [fileClaimId]="data.fileClaimId"
          [fileClaimNumber]="data.fileClaimNumber"
        ></fury-notes-table>
        <mat-paginator
          *ngIf="this.totalCount > 0"
          [pageSizeOptions]="[5, 30, 50, 100, 9999]"
          [pageSize]="pageSize"
          [length]="totalCount"
          [pageIndex]="pageIndex"
          (page)="pageSizeChange($event)"
          showFirstLastButtons
          [selectConfig]="selectConfig"
          [ngClass]="{ 'mat-pegig': pageSize === 9999 }"
          aria-label="Select page of periodic elements"
        >
        </mat-paginator>
      </mat-tab>
      </mat-tab-group>
    </div>
</div>